
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rims/personbil",
      function () {
        return require("private-next-pages/rims/personbil.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rims/personbil"])
      });
    }
  